import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=24536186"
import script from "./ImgPreview.vue?vue&type=script&lang=js"
export * from "./ImgPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports